// The apiClient response interceptor already toasts every failed HTTP call. It
// marks those errors so catch blocks skip a second toast for the same failure;
// errors it never saw (validation, `!data.ok` throws) are still toasted by callers.
const NOTIFIED = Symbol("notified");

export const markNotified = (error) => {
  if (error && typeof error === "object") error[NOTIFIED] = true;
  return error;
};

export const wasNotified = (error) => Boolean(error?.[NOTIFIED]);
